import axios, { AxiosError } from "axios"
import {
  AND_PARAM,
  CUSTOMER_PATH,
  FILTER_PARAM,
  LIST_PATH,
  OFFSET_PARAM,
  PAGE_SIZE_PARAM,
  SEARCH_PARAM,
} from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getCustomersService = async () => {
  try {
    const result = await instance.get(CUSTOMER_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getCustomerByIdentificationService = async (
  identification: string
) => {
  try {
    const result = await instance.get(CUSTOMER_PATH + `/${identification}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const getCustomersServicePaginated = async (
  filter: string,
  pageSize: number,
  offset: number
) => {
  try {
    const result = await instance.get(
      CUSTOMER_PATH +
        SEARCH_PARAM +
        FILTER_PARAM +
        filter +
        AND_PARAM +
        PAGE_SIZE_PARAM +
        pageSize +
        AND_PARAM +
        OFFSET_PARAM +
        offset
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createCustomerService = async (category: any) => {
  try {
    const result = await instance.post(CUSTOMER_PATH, category)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteCustomerService = async (id: any) => {
  try {
    const result = await instance.delete(CUSTOMER_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editCustomerService = async (id: number, category: any) => {
  try {
    const result = await instance.put(CUSTOMER_PATH + `/${id}`, category)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
